import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Site\UpdateSiteController::__invoke
* @see app/Http/Controllers/Site/UpdateSiteController.php
* @route '/api/site/{site}'
*/
const UpdateSiteController = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateSiteController.url(args, options),
    method: 'put',
})

UpdateSiteController.definition = {
    methods: ["put"],
    url: '/api/site/{site}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Site\UpdateSiteController::__invoke
* @see app/Http/Controllers/Site/UpdateSiteController.php
* @route '/api/site/{site}'
*/
UpdateSiteController.url = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { site: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { site: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            site: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        site: typeof args.site === 'object'
        ? args.site.id
        : args.site,
    }

    return UpdateSiteController.definition.url
            .replace('{site}', parsedArgs.site.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Site\UpdateSiteController::__invoke
* @see app/Http/Controllers/Site/UpdateSiteController.php
* @route '/api/site/{site}'
*/
UpdateSiteController.put = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateSiteController.url(args, options),
    method: 'put',
})

export default UpdateSiteController